import React, { useCallback, useEffect } from 'react'
import { Row, Col, Form } from 'react-bootstrap'
import { Calendar3Week } from 'react-bootstrap-icons'
import useViewport from '../../../hooks/use-viewport'
import Occurrence from './occurrence'
import { pullAt } from 'lodash'

const EditOccurrences = ({
    value = [],
    onChange = () => {},
}) => {
    const { breakpoint, breakpoints } = useViewport()
    useEffect(() => {
        if (!value || value.length < 1) {
            onChange([{ date: new Date(), hourId: '', durationId: '' }])
        }
    }, [value, onChange])

    const onOccurrenceChanged = useCallback((occurrence, index) => {
        value[index] = occurrence
        onChange([...value])
    }, [value, onChange])

    const onOccurrenceDelete = useCallback(index => {
        pullAt(value, index)
        onChange([...value])
    }, [value, onChange])

    const renderOccurrence = (occurrence, index) => {
        return (
            <Row key={index}>
                <Col>
                    <Occurrence
                        value={occurrence}
                        onChange={occurrence => onOccurrenceChanged(occurrence, index)}
                        buttonsVisible
                        removable={value.length > 1}
                        onAdd={() => onChange([...value, occurrence])}
                        onDelete={() => onOccurrenceDelete(index)}
                    />
                </Col>
            </Row>
        )
    }

    return (
        <React.Fragment>
            {value.map(renderOccurrence)}
        </React.Fragment>
    )
}

export default EditOccurrences